export default __webpack_public_path__ + "static/media/caps06.747e2bbb.gif";